interface FeatureHighlightItem {
  title: string;
  description: string;
}

interface FeatureHighlightsProps {
  eyebrow?: string;
  headline: React.ReactNode;
  description?: React.ReactNode;
  items: FeatureHighlightItem[];
  numbered?: boolean;
}

const FeatureHighlights = ({
  eyebrow,
  headline,
  description,
  items,
  numbered = false,
}: FeatureHighlightsProps) => {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        {eyebrow && (
          <div className="flex items-center gap-4 text-xs uppercase tracking-[0.18em] text-muted-foreground mb-4">
            <span className="h-px w-8 bg-border" />
            <span>{eyebrow}</span>
          </div>
        )}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <h2
            className="text-4xl md:text-5xl tracking-tight"
            style={{ fontFamily: "var(--font-display)" }}
          >
            {headline}
          </h2>
          {description && (
            <p className="text-base md:text-lg text-muted-foreground max-w-md md:text-right">
              {description}
            </p>
          )}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((item, index) => (
            <div
              key={item.title}
              className="rounded-xl border border-border bg-card/40 p-6 md:p-8 flex flex-col gap-3"
            >
              {numbered && (
                <span className="text-sm text-muted-foreground tabular-nums">
                  {String(index + 1).padStart(2, "0")}
                </span>
              )}
              <h3 className="text-lg font-medium text-foreground">{item.title}</h3>
              <p className="text-sm md:text-base leading-relaxed text-muted-foreground">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureHighlights;
